<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary border-bottom fixed-top">
    <div class="container">
      <router-link class="navbar-brand d-flex align-items-center" id="white-headline" to="/">
        <LogoComponent :fill="'#fff'" :height="'36px'" :width="'36px'" class="mr-3"/>CTO Flash
      </router-link>
<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" class="justify-content-between" is-nav>
      <b-navbar-nav class="mr-auto">
        <b-nav-item :to="{ name: 'DevicesView' }">Geräte und Konfigurationen</b-nav-item>
        <b-nav-item :to="{ name: 'ComponentsView' }">Komponenten</b-nav-item>
      </b-navbar-nav>

      <button type="button" class="btn btn-outline-primary" v-on:click="abmelden">
        <fa-icon icon="sign-out" fixed-width class="mr-2" />Abmelden
      </button>
      </b-collapse>
    </div>
  </nav>
</template>

<script>
import LogoComponent from './LogoComponent.vue'
import { auth } from '../plugins/firebase'
import { signOut } from "firebase/auth"

export default {
  name: 'NavbarComponent',
  components: {
    LogoComponent
  },
  methods: {
    abmelden: function() {
      signOut(auth)
      .then(() => this.$router.replace('/'))
      .catch(error => console.error(error.message)) // eslint-disable-line no-console
    }
  }
}
</script>

<style scoped>
.navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, 
.navbar-light .navbar-nav .nav-link.router-link-exact-active {
	color: rgba(0, 0, 0, 0.7);
}
a{
  color: rgba(255, 255, 255, 0.788) !important;
}
a:hover {
  color: rgb(255, 255, 255) !important;
}
#white-headline {
  color: #fff !important;
}
button {
  color: rgba(255, 255, 255, 0.788);
}
@media screen and (max-width:991px) {
  button.btn-outline-primary {
    padding-left: 0 !important;
  }
}
</style>
